import { useCallback } from "react";
import { viewOverrideId } from "./viewOverrideId";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { PAGE_CONFIGS, PageType } from "@/constants/PageType";
import { useUpdateAddIn } from "@/hooks/addins/useUpdateAddIn";
import { DiagnosticView, ViewOverride, ViewSettings } from "@/models/DiagnosticView";

export function useSaveViewOverride(pageType: PageType) {
  const addInId = PAGE_CONFIGS[pageType].addInId;
  const { me } = useGeotabClient();
  const updateAddIn = useUpdateAddIn<ViewOverride>(addInId, "id");

  const saveOverride = useCallback(
    async (view: DiagnosticView, gridStateDelta: string, settings?: Partial<ViewSettings>) => {
      if (!me?.id) return false;
      const id = viewOverrideId(me.id, view.id);
      return updateAddIn.mutateAsync({
        id,
        viewId: view.id,
        baseUpdatedAt: view.updatedAt,
        gridStateDelta,
        ...(settings ? { settings } : {}),
      });
    },
    [updateAddIn, me?.id],
  );

  return { saveOverride, isPending: updateAddIn.isPending };
}
